import http, { endpoints } from '../http';
import { mapArticleFromDto } from './helpers';
const efktClient = http.createClient(endpoints.efkt);
/**
 * EFKT-MOCK DOMAIN, and **NOT WIRED UP — kept for a future iteration.** `Efkt` has no help-article
 * concept today; this whole class is a guess, mirroring datahub's `SupportApi`
 * (`datahub/support/index.ts`). Help articles stay on datahub for v2: CMS content, not per-record
 * migrated data, taken out of the Efkt migration entirely (meeting 2026-09-22), so
 * `v2/modules/support/hooks.ts` calls `datahub.SupportApi` only. Leave this class here and un-called.
 *
 * No `getArticleContentById`, same reasoning as `efkt/news/index.ts`'s missing `getNewsById`: a
 * caller finds an article by id in its own already-fetched list instead of issuing a second request.
 */
export default class SupportApi {
    /** EFKT-MOCK — guessed path, mirrors datahub's `GET /help-articles/language/{language}`. */
    static async getArticles(locale) {
        let language = 'EN';
        if (locale.includes('da') || locale.includes('dk'))
            language = 'DA';
        if (locale.includes('sv') || locale.includes('se'))
            language = 'SV';
        if (locale.includes('no'))
            language = 'NO';
        if (locale.includes('vi'))
            language = 'VI';
        const response = await efktClient.get(`/api/help-articles/language/${language}`);
        return response.data.map(mapArticleFromDto);
    }
}
